<template>
  <div class="content-wrapper">
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
// const { ref } from 'vue';


// const isFullWidth = route.meta.push();
</script>
<style lang="less" scoped>
  .content-wrapper {
    // min-height: calc(100vh - 197px);
    // overflow: auto;
    // width: 1062px;
    // margin: 0 auto;
    // background-color: #fff;
    // margin-top: 22px;
  }
</style>
